import React, { useCallback, useContext, useEffect,useState } from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import axios from 'axios';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Swal from 'sweetalert2';
import { LoadingContext } from '../context/LoadingContext';
import ReactLoader from '../components/ReactLoader';
const config = require('../config.json')

export default function Profile({ipAddress, loginData}) {
    const [account] = useState(loginData?.address);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState();
    const [oldp, setOld] = useState('');
    const [newp, setNew] = useState('');
    const [rnew, setRnew] = useState('');
    const [loading, setLoading] = useContext(LoadingContext)
  const handleProfile = useCallback(() => {
    
    let data = JSON.stringify({
      "address": (loginData.address)?loginData.address:account,
      "ip": ipAddress,
      "ulid": loginData.ulid
    });
    
    let axiosConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${config.baseUrl}/api/profile`,
      headers: { 
        'address': (loginData.address)?loginData.address:account, 
        'ip': ipAddress, 
        'ulid': loginData.ulid, 
        'auth': loginData.auth, 
        'token': loginData.token, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    axios.request(axiosConfig)  
    .then((response) => {
        setName(response.data.data?.uname)
        setEmail(response.data.data?.uemail)
        setMobile(response.data.data?.umobile)   
    })
    .catch((error) => {
      // console.log(error);
    });
  },[account, ipAddress, loginData.address, loginData.auth, loginData.token, loginData.ulid])

  
  useEffect(() => {
    
    handleProfile()
  },[handleProfile])

  const handleProfileEdit = (e) => {
    e.preventDefault()
    let data = JSON.stringify({
      "address": (loginData.address)?loginData.address:account,
      "ip": ipAddress,
      "ulid": loginData.ulid,
      "uname" : name,
      "uemail"  : email,
      "umobile" : mobile
    });
    
    let axiosConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${config.baseUrl}/api/profileedit`,
      headers: { 
        'address': (loginData.address)?loginData.address:account, 
        'ip': ipAddress, 
        'ulid': loginData.ulid, 
        'auth': loginData.auth, 
        'token': loginData.token, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    // console.log(axiosConfig)
    setLoading(true)
    axios.request(axiosConfig)  
    .then((response) => {
      setLoading(false)
        setName(response.data.data?.uname)
        setEmail(response.data.data?.uemail)
        setMobile(response.data.data?.umobile)
        if(response.status)
        {
          Swal.fire({
            icon: 'info',
            title: 'LinkDao Defi',
            text: 'Your Profile Updated. Please Check Now.'
          });
        }
        else
        {
          Swal.fire({
            icon: 'warning',
            title: 'LinkDao Defi',
            text: 'Please Try again Later'
          });
        }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  const handlePass = (e) => {
    e.preventDefault()
    if(newp !== rnew && newp.length < 6)
    {
      Swal.fire({
        icon: 'warning',
        title: 'LinkDao Defi',
        text: 'Please Enter valid Password'
      });
    }
    let data = JSON.stringify({
      "address": (loginData.address)?loginData.address:account,
      "ip": ipAddress,
      "ulid": loginData.ulid,
      "opass" : oldp,
      "npass"  : newp,
      "rpass" : rnew
    });
    
    let axiosConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${config.baseUrl}/api/cpass`,
      headers: { 
        'address': (loginData.address)?loginData.address:account, 
        'ip': ipAddress, 
        'ulid': loginData.ulid, 
        'auth': loginData.auth, 
        'token': loginData.token, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    setLoading(true)
    axios.request(axiosConfig)  
    .then((response) => {
      console.log(response);
      setLoading(false)
      if(response.status)
      {
        Swal.fire({
          icon: 'info',
          title: 'LinkDao Defi',
          text: response.data.message
        });
      }
      else
      {
        Swal.fire({
          icon: 'warning',
          title: 'LinkDao Defi',
          text: response.message
        });
      }
      
    })
    .catch((error) => {
      console.log(error);
    });
  }
    return (
        <>
                <div className="layout-container">
                    <Menu />
                    <div className="layout-page">
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <div className="row">
                                    <div className='col-md-12'>
                                        <div className="card mb-4">
                                            <h5 className="card-header text-center text-info">Your Profile</h5>
                                            <div className="card-body">
                                                <form id="formAccountSettings" onSubmit={handleProfileEdit} className="fv-plugins-bootstrap5 fv-plugins-framework" noValidate="novalidate">
                                                    <div className="row">
                                                        <div className="mb-3 col-sm-6 fv-plugins-icon-container">
                                                            <label htmlFor="companyName" className="form-label">Full Name</label>
                                                            <input type="text" id="companyName" name="companyName" className="form-control" placeholder="ThemeSelection" value={name} onChange={(e) => {setName(e.target.value)}}/>
                                                            <div className="fv-plugins-message-container invalid-feedback" />
                                                        </div>
                                                        <div className="mb-3 col-sm-6 fv-plugins-icon-container">
                                                            <label htmlFor="billingEmail" className="form-label">Email</label>
                                                            <input className="form-control" type="text" id="email" name="email" placeholder="john.doe@example.com"  value={email} onChange={(e) => {setEmail(e.target.value)}}/>
                                                            <div className="fv-plugins-message-container invalid-feedback" />
                                                        </div>
                                                        <div className="mb-3 col-sm-6 fv-plugins-icon-container">
                                                            <label htmlFor="billingEmail" className="form-label">Smart Chain Address</label>
                                                            <input className="form-control" type="text"  placeholder="Your Address"  value={account} readOnly/>
                                                            <div className="fv-plugins-message-container invalid-feedback" />
                                                        </div>
                                                        <div className="mb-3 col-sm-6">
                                                            <label htmlFor="taxId" className="form-label">Contact Number</label>
                                                            <PhoneInput id="taxId" name="taxId" className="form-control" defaultCountry="US" placeholder="Contact Number" value={mobile} onChange={setMobile}/>
                                                        </div>
                                                    </div>
                                                    <div className="mt-2 text-center">
                                                        <button type="submit" className="btn btn-info me-2 text-sm btn-info">Update Address</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className="card mb-4">
                                            <h5 className="card-header text-center text-info">Update Password</h5>
                                            <div className="card-body">
                                                <form id="formAccountSettings" onSubmit={handlePass} className="fv-plugins-bootstrap5 fv-plugins-framework" noValidate="novalidate">
                                                    <div className="row">
                                                        <div className="mb-3 col-sm-6 fv-plugins-icon-container">
                                                            <label htmlFor="companyName" className="form-label">Old Password</label>
                                                            <input type="text" id="companyName" name="companyName" className="form-control" placeholder="Old Passowd" value={oldp} onChange={(e) => {setOld(e.target.value)}}/>
                                                            <div className="fv-plugins-message-container invalid-feedback" />
                                                        </div>
                                                        <div className="mb-3 col-sm-6 fv-plugins-icon-container">
                                                            <label htmlFor="billingEmail" className="form-label">New Password</label>
                                                            <input className="form-control" type="text" id="email" name="email" placeholder="Enter New Password"  value={newp} onChange={(e) => {setNew(e.target.value)}}/>
                                                            <div className="fv-plugins-message-container invalid-feedback" />
                                                        </div>
                                                        <div className="mb-3 col-sm-6 fv-plugins-icon-container">
                                                            <label htmlFor="billingEmail" className="form-label">Re-enter New Password</label>
                                                            <input className="form-control" type="password"  placeholder="Re-Enter New Password"  value={rnew} onChange={(e) => {setRnew(e.target.value)}} />
                                                            <div className="fv-plugins-message-container invalid-feedback" />
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="mt-2 text-center">
                                                        <button type="submit" className="btn btn-info me-2 text-sm btn-info">Update Password</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
        </>
    );
}